<template>
  <v-card class="page ma-0">
    <div :style="styleObject" id="page_wrapper">
      <div style="width: 95%" class="py-2">
        <slot name="title"></slot>
      </div>
      <table class="printTable" :dir="$vuetify.rtl ? 'rtl' : 'ltr'">
        <thead>
          <slot name="header"></slot>
        </thead>
        <tbody>
          <slot name="body"></slot>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div :style="{ width: styleObject.width }" class="py-3 px-4 theme--light">
        <slot name="footer"></slot>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    styleObject: {
      default: { "min-height": "290mm", width: "200mm" }
    }
  },
  data: () => ({
    phones: [" +93 789560038"],
    email: "info@aicsafg.org"
  })
};
</script>

<style>
#page_wrapper {
  display: flex;
  padding-top: 20px;
  align-items: center;
  padding-bottom: 20px;
  flex-direction: column;
}

table.printTable {
  border-collapse: collapse;
  width: 94%;
}

table.printTable tr,
table.printTable td {
  vertical-align: middle;
  text-align: center;
  padding: 3px 5px;
  border: 1px solid black;
  font-family: "IR_M";
  font-size: 11px;
}

.wrap-text td {
  word-break: break-all;
}

@media print {
  table {
    page-break-after: auto;
  }

  @-moz-document url-prefix() {
    body {
      display: block;
    }
  }
  tr {
    page-break-inside: avoid;
    page-break-after: always;
  }

  td {
    page-break-after: auto;
  }

  tbody {
    display: table-row-group;
  }

  thead {
    padding-top: 20px;
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  .page {
    box-shadow: none !important;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  #page_wrapper {
    padding: 0;
  }

  .f_10 {
    font-size: 8pt;
  }

  .f_11 {
    font-size: 8pt;
  }

  .f_12 {
    font-size: 9pt;
  }

  .f_13 {
    font-size: 10pt;
  }

  .f_14 {
    font-size: 11pt;
  }

  .f_16 {
    font-size: 12pt;
  }

  .f_18 {
    font-size: 14pt;
  }

  .f_20 {
    font-size: 15pt;
  }
}
</style>
